import { ReactNode } from 'react';

export interface TabPanelsProps<T extends string> {
  value: T;
  panels: Partial<Record<T, ReactNode>>;
  fallback: T;
}

export const TabPanels = <T extends string>({
  value,
  panels,
  fallback,
}: TabPanelsProps<T>) => panels[value] ?? panels[fallback] ?? null;
